import React  from 'react';
import './CatalogueItem.scss';
import ProductImage from '../ProductImage';

type Props = {
  imageCode: string;
  productName: string;
  productDetails: string;
  price: number;
  onClick: () => void;
};
const CatalogueItem = (props: Props) => {

  const { imageCode, productName, productDetails, onClick } = props;


  return (
        <div className="catalogueItem" onClick={onClick}>
            <div className="catalogueItem__img">
                <ProductImage imageCode={imageCode} imageAlt={productName} />
            </div>
            <div className="catalogueItem__description">
                <p>{productName}</p>
                <p>{productDetails}</p>
                {/*<div className="catalogueItem__description__price">*/}
                {/*    <p style={{ color: '#E26329', marginTop: '1rem' }}>£{props.price}</p>*/}
                {/*    <p style={{ fontWeight: 400 }}>(£11.00 per SQM)</p>*/}
                {/*</div>*/}
            </div>
        </div>
  );
};

export default CatalogueItem;
